import React, { FC, useState, useRef } from 'react';
import { isEmpty } from 'lodash';
import styled from 'styled-components';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { overrides } from '@cld/button';
import { globalTheme } from '@cld/component-theme';
import { typography } from '@cld/typography';
import { messages } from '../../../../i18n';
import { setCredentials } from '../../../../actions';
import { useAnalytics } from '../../../../hooks/useAnalytics';
import { FormRow } from './FormRow';
import { Info } from './Info';

const { Button } = overrides.mediaLibraryWidgetDemoOverrides;

const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${globalTheme.spacing.xl};
`;

const Heading = styled.div`
  ${typography.sm.regular};
  display: block;
  padding-bottom: ${globalTheme.spacing.xl};
`;

export const AccountCredentials: FC = () => {
  const analytics = useAnalytics();

  const [cloudName, setCloudName] = useState('');
  const [apiKey, setApiKey] = useState('');

  const cloudNameRef = useRef<HTMLInputElement>(null);
  const apiKeyRef = useRef<HTMLInputElement>(null);

  const { formatMessage } = useIntl();

  const dispatch = useDispatch();

  const handleLogin = () => {
    analytics('login', 'submitted cloud name and api key to demo');

    if (isEmpty(cloudName)) {
      cloudNameRef.current?.focus();
    } else if (isEmpty(apiKey)) {
      apiKeyRef.current?.focus();
    } else {
      dispatch(setCredentials({ cloudName, apiKey }));
    }
  };

  return (
    <Root>
      <Heading>
        <FormattedMessage {...messages['loginModal.main.accountCredentials.text']} />
      </Heading>
      <FormRow
        label={formatMessage(messages['loginModal.main.accountCredentials.inputs.cloudName.label'])}
        inputType="text"
        iconName="cloud"
        value={cloudName}
        onChange={setCloudName}
        inputRef={cloudNameRef}
        onEnter={handleLogin}
        fieldId="cloudName"
      />
      <FormRow
        label={formatMessage(messages['loginModal.main.accountCredentials.inputs.apiKey.label'])}
        inputType="password"
        iconName="authenticated"
        value={apiKey}
        onChange={setApiKey}
        inputRef={apiKeyRef}
        onEnter={handleLogin}
        fieldId="apiKey"
      />
      <Info />
      <Button data-test="login-button" onClick={handleLogin}>
        <FormattedMessage {...messages['loginModal.main.accountCredentials.start']} />
      </Button>
    </Root>
  );
};
